export default "__VITE_ASSET__CgyyXozM__"